import { ReactElement } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Badge } from '../../../ui/Badge/Badge';

type NavLinkProps = {
    label: string;
    to: string;
    badge?: string | number;
    icon?: ReactElement;
    onClick?: () => void;
};

export const NavLink = ({ label, to, badge, icon, onClick }: NavLinkProps) => {
    const location = useLocation();

    const active: boolean = location.pathname + location.search === to;

    return (
        <li className="h-full flex">
            <Link
                className={`relative font-semibold px-1 hover:text-green-400 hover:opacity-100 transition-colors duration-150 ease-in-out no-underline flex items-center leading-none  ${
                    active ? 'text-green-400' : 'text-white '
                }`}
                to={to}
                onClick={onClick}
            >
                {icon && <span className="mr-3">{icon}</span>}
                <span>{label}</span>
                <div
                    className={`absolute bottom-0 left-0 right-0 h-[5px] ${active ? 'bg-green-400' : 'bg-transparent'}`}
                />
                {badge && (
                    <div className="ml-1">
                        <Badge badgeStyle="primary">{badge}</Badge>
                    </div>
                )}
            </Link>
        </li>
    );
};
